<mat-form-field appearance="outline" subscriptSizing="dynamic" class="member-search">
  <mat-icon matPrefix>add</mat-icon>
  <input matInput [placeholder]="placeholder() | translate" [(ngModel)]="text" (ngModelChange)="search$.next($event)"
    [matAutocomplete]="auto" [attr.aria-label]="placeholder() | translate" />

  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="pick($event)">
    @for (option of options(); track option.id) {
      <mat-option [value]="option">
        <span class="label">{{ option.label }}</span>
        @if (option.sublabel) {
          <span class="sublabel">{{ option.sublabel }}</span>
        }
      </mat-option>
    }
  </mat-autocomplete>
</mat-form-field>
